import { createContext, useContext, useState, ReactNode, useCallback } from 'react'
import { Toast } from './Toast'

const TWENTY_SECS = 20 * 1000

type ToastContextType = {
  showToast: (message: string, usage: string, total: string) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [message, setMessage] = useState('token-usage-report')
  const [usage, setUsage] = useState('')
  const [total, setTotal] = useState('')

  const showToast = useCallback((msg: string, usage: string, total: string) => {
    setMessage(msg)
    setUsage(usage)
    setTotal(total)
    setIsVisible(true)
    setTimeout(() => setIsVisible(false), TWENTY_SECS)
  }, [])

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        onClose={() => setIsVisible(false)}
        onSubmit={() => console.log('submitted')}
        message={message}
        isVisible={isVisible}
        usage={usage}
        total={total}
      />
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast must be used within a ToastProvider')
  return context
}
